import { getProgressTrackerItemState, ProgressTracker, ProgressTrackerItem } from "@octopusdeploy/design-system-components";
import React from "react";
import type { PagedOnboardingDialogPageData, PageNavigation } from "./PagedOnboardingDialog";
type PagedOnboardingDialogProgressTrackerProps = {
    pages: PagedOnboardingDialogPageData[];
    pageNavigation: PageNavigation;
};
export function PagedOnboardingDialogProgressTracker({ pages, pageNavigation }: PagedOnboardingDialogProgressTrackerProps) {
    return (<div style={{ flexShrink: 0 }}>
            <ProgressTracker>
                {pages.map((page, index) => !!page.progressTrackerLabel ? <ProgressTrackerItem key={index} label={page.progressTrackerLabel} state={getProgressTrackerItemState(index, pageNavigation.currentPageIndex)}></ProgressTrackerItem> : <div key={index}/>)}
            </ProgressTracker>
        </div>);
}
